import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center login-canvas">
        <div className="text-brand-mutedFg" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Force password change before any other action (URL reflects state).
  if (user.must_change_password && !location.pathname.startsWith("/change-password")) {
    return <Navigate to="/change-password" replace state={{ forced: true, from: location.pathname }} />;
  }

  return children;
}
